import CroustilleElement from '../lib/CroustilleElement'

class Split extends CroustilleElement {
  constructor() {
    super('split')
  }

  get text() {
    return this.child('text')
  }

  get image() {
    return this.child('image')
  }

  setMinH() {
    const imageMinH = this.image.offsetHeight
    const textMinH = this.text.offsetHeight

    if (imageMinH >= textMinH && window.innerWidth >= 768) {
      this.text.style.minHeight = `${imageMinH}px`
    } else {
      this.text.style.minHeight = ''
    }
  }

  init() {
    this.setMinH()
  }

  resized() {
    this.setMinH()
  }

  destroy() {}
}

export default Split
